// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
historySearch();
testSearch();
});


import wixData from 'wix-data';

function eventSearch(){

$w("#dataset3").onReady( () => {
		console.log("The dataset is ready");
		var local = new Date().toLocaleDateString();
    console.log(local +"2");
		$w("#dataset3").setFilter( wixData.filter()
		  .contains("date", local)
		  .and(wixData.filter()
			.eq("archive", false)
		)
		)
		.then( (res) => {
			  console.log(res.length);
		  console.log("Dataset is now filtered");
		} )
		.catch( (err) => {
		  console.log(err);
		} );
	});

}

function historySearch(){
var today = new Date().toISOString().slice(0,10);
var local = new Date().toLocaleDateString();
console.log(local);
 // Gets today's date
 //const today = new Date();
// const Jtoday = new Date(today);
 //	today.setHours(0,0,0,0);
   wixData.query("History")
        .contains("title", local)
        .limit(1)
        .find()
        .then((res) => {
            console.log(res.length)
              $w('#history').data = res.items;
  if (res.length < 1 || res === null) {
             //$w("#noEvent").expand();
		     $w("#historyStrip").collapse();
             }  
        else {
        	//$w("#noEvent").collapse();
            $w("#historyStrip").expand();
	}   
        })
        .catch((err) => {
 let errorMsg = err;
        });


}

function testSearch(){
var today = new Date().toISOString().slice(0,10);
var local = new Date().toLocaleDateString();
console.log(local);
 // Gets today's date
 //const today = new Date();
// const Jtoday = new Date(today);
 //	today.setHours(0,0,0,0);
   wixData.query("events")
        .contains("date", local)
        .limit(1)
        .find()
        .then((res) => {
            console.log(res.length+"2")
              $w('#repeater1').data = res.items;
  if (res.length < 1 || res === null) {
             //$w("#noEvent").expand();
		     $w("#repeater1").hide();
             }  
        else {
        	//$w("#noEvent").collapse();
            $w("#repeater1").show();
	}   
        })
        .catch((err) => {
 let errorMsg = err;
        });


}